module.exports = __webpack_public_path__ + "img/disease.b22d32f4.svg";